"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.DropdownContext = void 0;

var _react = _interopRequireDefault(require("react"));

/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 * }
 */
var DropdownContext = _react.default.createContext({});

exports.DropdownContext = DropdownContext;


//////////////////
// WEBPACK FOOTER
// ./~/reactstrap/lib/DropdownContext.js
// module id = 22
// module chunks = 0